import React from 'react'
import ExecutiveForm from './ExecutiveForm'

function EditExecutive() {
    return (
        <div><ExecutiveForm type="EDIT" /></div>
    )
}

export default EditExecutive